import ShowMoreText from 'react-show-more-text';

import useStyles from './styles';

export const ReadMore = ({ children: text, lines = 2 }: { children: string; lines?: number }) => {
  const classes = useStyles();

  return (
    <ShowMoreText
      lines={lines}
      more="Read more"
      less="Read less"
      className={classes.showMoreTextContent}
      anchorClass={classes.showMoreTextAnchor}
      expanded={false}
      truncatedEndingComponent={'... '}>
      {text}
    </ShowMoreText>
  );
};
